import React, { useMemo } from 'react';

import { Link as PrismLink } from '@nutanix-ui/prism-reactjs';
import type { LinkProps as PrismLinkProps } from '@nutanix-ui/prism-reactjs/lib/components/v2/Typography/Link';
import { useHistory } from 'react-router';

export type LinkProps = PrismLinkProps & {
  external?: boolean;
};

export default function Link({ external, ...props }: React.PropsWithChildren<LinkProps>) {
  const history = useHistory();
  const handleClick = external
    ? props.onClick
    : (e: React.MouseEvent) => {
        const url = props.href as string;
        history.push(`${url}#main-content`);
        e.preventDefault();
      };
  const href = useMemo(() => (props.disabled ? undefined : props.href), [props.disabled, props.href]);

  return (
    <PrismLink
      {...props}
      href={href}
      onClick={handleClick}
      {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
    />
  );
}
